import React, { useEffect, useState } from "react";
import { Button, Form } from "reactstrap";
import useAxios from "../../../../Utils/useAxios";
import {
  unitKerjaAxiosCreate,
  unitKerjaAxiosUpdate,
} from "../../../../Utils/axiosFunctions";
import { toastSuccess } from "../../../../Utils/toastFunctions";
import {
  berhasilMembuatItemMsg,
  berhasilMengeditItemMsg,
} from "../../../../Constant/Message";
import { InputField } from "../../../../CommonElements";

const UnitKerjaBaruForm = ({ resetState, toggle, uk }) => {
  const [state, setUkState] = useState({
    kode_unit_kerja: "",
    nama_unit_kerja: "",
    nama_kepala: "",
    nama_jabatan: "",
    email_milis: "",
    nama_unit_kerja_lokal: "",
    email_pic: "",
    show: "",
    kode_baru: "",
  });

  useEffect(() => {
    if (uk) {
      const {
        kode_unit_kerja,
        nama_unit_kerja,
        nama_kepala,
        nama_jabatan,
        email_milis,
        nama_unit_kerja_lokal,
        email_pic,
        show,
        kode_baru,
      } = uk;

      setUkState({
        kode_unit_kerja: kode_unit_kerja,
        nama_unit_kerja: nama_unit_kerja,
        nama_kepala: nama_kepala,
        nama_jabatan: nama_jabatan,
        email_milis: email_milis,
        nama_unit_kerja_lokal: nama_unit_kerja_lokal,
        email_pic: email_pic,
        show: show,
        kode_baru: kode_baru,
      });
    }
  }, [uk]);

  const axiosInstance = useAxios();

  const createUnitKerja = (e) => {
    e.preventDefault();
    unitKerjaAxiosCreate(axiosInstance, state).then(() => {
      resetState();
      toggle();
      toastSuccess(berhasilMembuatItemMsg("unit kerja"));
    });
  };

  const editUnitKerja = (e) => {
    e.preventDefault();
    unitKerjaAxiosUpdate(axiosInstance, uk.pk, state).then(() => {
      resetState();
      toggle();
      toastSuccess(berhasilMengeditItemMsg("unit kerja"));
    });
  };

  return (
    <Form onSubmit={uk ? (e) => editUnitKerja(e) : (e) => createUnitKerja(e)}>
      <InputField
        state={state}
        label={"Kode Unit Kerja"}
        name={"kode_unit_kerja"}
        onChange={(e) => {
          setUkState((prev) => ({
            ...prev,
            kode_unit_kerja: e.target.value,
          }));
        }}
      />
      <InputField
        state={state}
        label={"Nama Unit Kerja"}
        name={"nama_unit_kerja"}
        onChange={(e) => {
          setUkState((prev) => ({
            ...prev,
            nama_unit_kerja: e.target.value,
          }));
        }}
      />
      <InputField
        state={state}
        label={"Nama Kepala"}
        name={"nama_kepala"}
        onChange={(e) => {
          setUkState((prev) => ({ ...prev, nama_kepala: e.target.value }));
        }}
      />
      <InputField
        state={state}
        label={"Nama Jabatan"}
        name={"nama_jabatan"}
        onChange={(e) => {
          setUkState((prev) => ({ ...prev, nama_jabatan: e.target.value }));
        }}
      />
      <InputField
        state={state}
        label={"Email"}
        name={"email_milis"}
        onChange={(e) => {
          setUkState((prev) => ({ ...prev, email_milis: e.target.value }));
        }}
      />
      <InputField
        state={state}
        label={"Nama Unit Kerja Lokal"}
        name={"nama_unit_kerja_lokal"}
        onChange={(e) => {
          setUkState((prev) => ({
            ...prev,
            nama_unit_kerja_lokal: e.target.value,
          }));
        }}
      />
      <InputField
        state={state}
        label={"Email PIC"}
        name={"email_pic"}
        onChange={(e) => {
          setUkState((prev) => ({ ...prev, email_pic: e.target.value }));
        }}
      />
      <InputField
        state={state}
        label={"Show"}
        name={"show"}
        onChange={(e) => {
          setUkState((prev) => ({ ...prev, show: e.target.value }));
        }}
      />
      <InputField
        state={state}
        label={"Kode Unit Kerja Baru"}
        name={"kode_baru"}
        onChange={(e) => {
          setUkState((prev) => ({ ...prev, kode_baru: e.target.value }));
        }}
      />

      <Button color="primary">Simpan</Button>
    </Form>
  );
};

export default UnitKerjaBaruForm;
